const API_BASE = "https://api.production.higher.systems";
const LOGIN_PATH = "/v1/authentication/login";
export const JWT_STORAGE_KEY = "jwt_token";
export const SERVICES_ENABLE_KEY = "services_enable";

export function getEnvOrLS(key, fallback = "") {
  return (
    localStorage.getItem(key) ||
    process.env[`REACT_APP_${key.toUpperCase()}`] ||
    fallback
  );
}

export function getStaticCreds() {
  return {
    basicAuth: "Basic YWIyMTRjMjQtMTc0ZS00NTkyLWI3ODAtMTkxMmQxMTM3Y2M4OjEyMzQ=", //getEnvOrLS('auth_header', ''),
    xtenant: "ab214c24-174e-4592-b780-1912d1137cc8", //getEnvOrLS('xtenant', ''),
    serviceaccountname: "adm", //getEnvOrLS('serviceaccountname', getEnvOrLS('service_account', '')),
    apikey: "a492bdb0-838a-49c3-9e7e-ad3e9c1d24a7", //getEnvOrLS('apikey', ''),
  };
}

function parseTokenMaybeJSON(raw) {
  try {
    const j = JSON.parse(raw);
    return (
      j?.token ||
      j?.jwt ||
      j?.accessToken ||
      j?.data?.token ||
      j?.data?.jwt ||
      ""
    );
  } catch {
    return (raw || "").replace(/^"|"$/g, "").trim();
  }
}

function normalizeServicesEnable(input) {
  const toBool = (v) => !!v;
  if (!input) return { baas: false, ramps: false };

  if (typeof input === "string") {
    const s = input.toUpperCase();
    if (s === "ALL") return { baas: true, ramps: true };
    if (s === "BAAS") return { baas: true, ramps: false };
    if (s === "RAMP" || s === "RAMPS") return { baas: false, ramps: true };
    return { baas: false, ramps: false };
  }

  if (Array.isArray(input)) {
    const U = input.map((x) => String(x || "").toUpperCase());
    return {
      baas: U.includes("ALL") || U.includes("BAAS"),
      ramps: U.includes("ALL") || U.includes("RAMP") || U.includes("RAMPS"),
    };
  }

  if (typeof input === "object") {
    const baas = toBool(input.baas) || String(input.enable).toUpperCase() === "BAAS";
    const ramps =
      toBool(input.ramps) ||
      String(input.enable).toUpperCase() === "RAMP" ||
      String(input.enable).toUpperCase() === "RAMPS";
    return { baas, ramps };
  }

  return { baas: false, ramps: false };
}

export function setServicesEnableFromAny(input) {
  const norm = normalizeServicesEnable(input);
  localStorage.setItem(SERVICES_ENABLE_KEY, JSON.stringify(norm));
  return norm;
}

export function getServicesEnableRaw() {
  return localStorage.getItem(SERVICES_ENABLE_KEY);
}

export function getServicesEnable() {
  const raw = getServicesEnableRaw();
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && "baas" in parsed && "ramps" in parsed) {
      return parsed;
    }
    return normalizeServicesEnable(parsed);
  } catch {
    return normalizeServicesEnable(raw);
  }
}

export function hasRampsEnabled() {
  const { ramps } = getServicesEnable();
  return !!ramps;
}
export function hasBaasEnabled() {
  const { baas } = getServicesEnable();
  return !!baas;
}

export const Services = Object.freeze({ ALL: "ALL", BAAS: "BAAS", RAMP: "RAMP" }); 
export function isServiceEnabled(service) {                                        
  const flag = getServicesEnable();
  if (service === Services.BAAS) return !!flag.baas;
  if (service === Services.RAMP) return !!flag.ramps;
  if (service === Services.ALL) return !!flag.baas && !!flag.ramps;
  return false;
}

export function clearAuthAndFlags() {
  localStorage.removeItem(JWT_STORAGE_KEY);
  localStorage.removeItem(SERVICES_ENABLE_KEY);
}

export async function loginJwt() {
  const { basicAuth } = getStaticCreds();
  if (!basicAuth)
    throw new Error(
      "Falta Authorization Basic (auth_header / REACT_APP_AUTH_HEADER)"
    );

  const res = await fetch(API_BASE + LOGIN_PATH, {
    method: "POST",
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
      Authorization: basicAuth,
    },
  });

  const raw = await res.text();
  if (!res.ok) throw new Error(`Login JWT HTTP ${res.status} ${raw}`);

  try {
    const json = JSON.parse(raw);
    const services =
      json?.services ??
      json?.enable ??
      json?.body?.services ??
      json?.body?.enable;

    if (services) {
      setServicesEnableFromAny(services);
    } else {
      localStorage.removeItem(SERVICES_ENABLE_KEY);
    }
  } catch {
    localStorage.removeItem(SERVICES_ENABLE_KEY);
  }

  const token = parseTokenMaybeJSON(raw);
  if (!token) throw new Error("Login JWT vacío");
  localStorage.setItem(JWT_STORAGE_KEY, token);
  return token;
}

export async function getJwt() {
  return localStorage.getItem(JWT_STORAGE_KEY) || (await loginJwt());
}

export function buildAuthHeaders(
  jwt,
  {
    casing = "title",
    accept = "application/json",
    contentType = "application/json",
  } = {}
) {
  const { xtenant, serviceaccountname, apikey } = getStaticCreds();
  const H = { Accept: accept, "Content-Type": contentType };
  if (jwt) H.Authorization = `Bearer ${jwt}`;

  const keys =
    casing === "lower"
      ? { tenant: "xtenant", sa: "serviceaccountname", key: "apikey" }
      : { tenant: "X-Tenant", sa: "ServiceAccountName", key: "APIKEY" };

  if (xtenant) H[keys.tenant] = xtenant;
  if (serviceaccountname) H[keys.sa] = serviceaccountname;
  if (apikey) H[keys.key] = apikey;

  return H;
}

function buildURL({ url, path, query }) {
  const u = url || API_BASE + (path?.startsWith("/") ? path : `/${path || ""}`);
  const out = new URL(u);
  if (query && typeof query === "object") {
    Object.entries(query).forEach(([k, v]) => {
      if (v !== undefined && v !== null) out.searchParams.set(k, String(v));
    });
  }
  return out.toString();
}

export async function requestRaw({
  url,
  path,
  method = "GET",
  query,
  body,
  casing = "title",
  accept = "application/json",
  contentType = "application/json",
  includeAuth = true,
}) {
  const doFetch = async (jwt) => {
    const headers = includeAuth
      ? buildAuthHeaders(jwt, { casing, accept, contentType })
      : { Accept: accept, "Content-Type": contentType };
    const finalURL = buildURL({ url, path, query });
    const init = { method, headers };
    if (body !== undefined)
      init.body = typeof body === "string" ? body : JSON.stringify(body);
    return fetch(finalURL, init);
  };

  let jwt = includeAuth ? await getJwt() : null;
  let res = await doFetch(jwt);

  if (res.status === 401 && includeAuth) {
    clearAuthAndFlags();                 
    jwt = await loginJwt();
    res = await doFetch(jwt);
  }

  const text = await res.text().catch(() => "");
  return { ok: res.ok, status: res.status, text, url: res.url };
}

export async function requestJson(opts) {
  const { ok, status, text, url } = await requestRaw(opts);
  if (!ok) {
    console.error(`[apiClient] ${status} on ${url}`, text);
    const err = new Error(`HTTP ${status}: ${text || "(sin cuerpo)"}`);
    err.status = status;
    err.text = text;
    throw err;
  }
  try {
    return JSON.parse(text || "{}");
  } catch {
    const err = new Error("Respuesta no JSON");
    err.status = status;
    err.text = text;
    throw err;
  }
}

function toReq(method, urlOrPath, body, config = {}) {
  const {
    query,
    accept = "application/json",
    contentType = "application/json",
    casing = "lower",
    includeAuth = true,
  } = config || {};

  const opts = {
    method,
    query,
    body,
    accept,
    contentType,
    casing,
    includeAuth,
  };

  if (typeof urlOrPath === "string" && /^https?:\/\//i.test(urlOrPath)) {
    opts.url = urlOrPath;
  } else {
    opts.path = urlOrPath;
  }

  return requestJson(opts);
}

const apiClient = {
  get: (urlOrPath, config) => toReq("GET", urlOrPath, undefined, config),
  post: (urlOrPath, body, config) => toReq("POST", urlOrPath, body, config),
};

export default apiClient;


